<form [formGroup]='clientForm' (ngSubmit)="onClientSave()">
  <table width="100%">
    <!-- <div style="border: 1px black solid; width:100%"> -->
      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.FIRST_NAME' | translate }} *</mat-label>
            <input matInput [placeholder]="'AUTH.FIRST_NAME' | translate" type="text" name='firstName' formControlName="firstName" clearInput />
          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td *ngIf="!firstName.valid && submitted">
          <p *ngIf="firstName.hasError('required')" class='smr-error'>
            {{ 'AUTH.FIRST_NAME_REQUIRED' | translate }}
          </p>

          <p *ngIf="firstName.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.FIRST_NAME_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>
      
      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.LAST_NAME' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.LAST_NAME' | translate" type="text" name='lastName' formControlName="lastName" clearInput />
          </mat-form-field>
        </td>
      </tr>
      
      <tr>
        <td  *ngIf="!lastName.valid && submitted">
          <p *ngIf="lastName.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.LAST_NAME_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.EMAIL' | translate }} *</mat-label>
            <input matInput [placeholder]="'AUTH.EMAIL' | translate" type="email" name='email' formControlName="email" clearInput />

            <mat-hint *ngIf='email.pending' align="end">
              {{ 'AUTH.CHECKING_EMAIL' | translate }}
            </mat-hint>

          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td  *ngIf="!email.valid">
          <p *ngIf="email.hasError('required') && submitted" class='smr-error'>
            {{ 'AUTH.EMAIL_REQUIRED' | translate }}
          </p>

          <p *ngIf="email.hasError('validateEmail') && submitted" class='smr-error'>
            {{ 'AUTH.EMAIL_INVALID' | translate }}
          </p>

          <p *ngIf="email.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.EMAIL_MAXLENGTH' | translate }}
          </p>

          <p *ngIf="email.hasError('clientEmailAlreadyExists')" class='smr-error' (click)="onViewLogIn()" style="cursor:pointer;display:inline-block;">
            {{ 'AUTH.EMAIL_IN_USE' | translate }}
          </p>
        </td>
      </tr>
    <!-- </div> -->

    <tr>
      <td>
        <mat-form-field sm-full-width appearance="outline">
          <mat-label>{{ 'AUTH.PASSWORD' | translate }}</mat-label>
          <input matInput [placeholder]="'AUTH.PASSWORD' | translate" type="password" name='password' formControlName="password" clearInput />
        </mat-form-field>
      </td>
    </tr>

    <tr>
      <td  *ngIf="reqPass && !password.valid && submitted">
        <p *ngIf="password.hasError('required')" class='smr-error'>
          {{ 'AUTH.PASSWORD_REQUIRED' | translate }}
        </p>

        <p *ngIf="password.hasError('maxlength')" class='smr-error'>
          {{ 'AUTH.PASSWORD_MAXLENGTH' | translate }}
        </p>
      </td>
    </tr>

    <tr>
      <td>
        <mat-form-field sm-full-width appearance="outline">
          <mat-label>{{ 'AUTH.MOBILE_PHONE' | translate }} *</mat-label>
          <input matInput [placeholder]="'AUTH.MOBILE_PHONE' | translate" type="tel" name='phone2' formControlName="phone2" clearInput />
        </mat-form-field>
      </td>
    </tr>

    <tr>
      <td *ngIf="!phone2.valid && submitted">

        <p *ngIf="phone2.hasError('required')" class='smr-error'>
          {{ 'AUTH.MOBILE_PHONE_REQUIRED' | translate }}
        </p>

        <p *ngIf="phone2.hasError('maxlength')" class='smr-error'>
          {{ 'AUTH.PHONE_MAXLENGTH' | translate }}
        </p>
        <p *ngIf="phone2.hasError('validatePhone')" class='smr-error'>
          {{ 'AUTH.PHONE_INVALID' | translate }}
        </p>
      </td>
    </tr>

    <div *ngIf="reqAddress">

      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.ADDRESS_1' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.ADDRESS_1' | translate" type="text" name='address1' formControlName="address1" />
          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td *ngIf="!address1.valid && submitted">
          <p *ngIf="address1.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.ADDRESS_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.ADDRESS_2' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.ADDRESS_2' | translate" type="text" name='address2' formControlName="address2" />
          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td *ngIf="!address2.valid && submitted">
          <p *ngIf="address2.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.ADDRESS_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.CITY' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.CITY' | translate" type="text" name='city' formControlName="city" />
          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td *ngIf="!city.valid && submitted">
          <p *ngIf="city.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.CITY_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.STATE_PROVINCE' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.PROVINCE' | translate" type="text" name='province' formControlName="province" />
          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td *ngIf="!province.valid && submitted">
          <p *ngIf="province.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.PROVINCE_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.POSTAL_CODE' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.POSTAL' | translate" type="text" name='postal' formControlName="postal" />
          </mat-form-field>
        </td>
      </tr>

      <tr>
        <td *ngIf="!postal.valid && submitted">
          <p *ngIf="postal.hasError('maxlength')" class='smr-error'>
            {{ 'AUTH.POSTAL_MAXLENGTH' | translate }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <mat-select [placeholder]="'AUTH.SELECT_COUNTRY' | translate" name="country" formControlName="country">
            <mat-label>{{ 'AUTH.COUNTRY' | translate }}</mat-label>
            <mat-option *ngFor="let country of countries" [value]="country.getID()">
              {{country.getCountryName()}}
            </mat-option>
          </mat-select>
        </td>
      </tr>
    </div>
  </table>
  <br />
  <div>
    <button mat-raised-button primaryButton sm-full-width type="submit" >{{ 'AUTH.SIGN_UP_BUTTON' | translate }}</button>
    <p style="text-align: center; color: #666; margin-top: 1em;">{{ 'AUTH.REQUIRED_LEGEND' | translate }}</p>
  </div>
</form>
